<bevvi-bot-chat-card
  [type]="type.MULTISELECT"
  [title]="payload().question || ''"
  [description]="payload().description || ''"
  [options]="payload().options"
  [showActions]="true"
  [primaryButtonText]="payload().submitText || 'Submit'"
  [disabled]="disabled()"
  (optionChange)="onOptionChange($event)"
  (submitClick)="onSubmit()"
/>
